import React, { useEffect } from "react";
import { ReactComponent as LaptopImage } from "./images/laptop.svg";
import gsap from "gsap";

const LAPTOP_SVG_LAYOUT =
  "lg:h-1/3 lg:w-1/3 lg:mx-10 self-end w-full h-full";

export default function Laptop({ className = "", animate = true }) {
  useEffect(() => {
    if (!animate) return undefined;

    const codeLines = [
      "#code-line1",
      "#code-line2",
      "#code-line3",
      "#code-line4",
      "#code-line5",
      "#code-line6",
      "#code-line7",
      "#code-line8",
      "#code-line9",
    ];
    const codeLinesReversed = [
      "#code-line9",
      "#code-line8",
      "#code-line7",
      "#code-line6",
      "#code-line5",
      "#code-line4",
      "#code-line3",
      "#code-line2",
      "#code-line1",
    ];

    const linesAnimation = gsap.timeline({ repeat: -1 });
    linesAnimation
      .from(codeLines, {
        duration: 0.3,
        scaleX: 0,
        stagger: 0.3,
        ease: "power1.out",
      })
      .to(codeLinesReversed, {
        duration: 0.3,
        scaleX: 0,
        stagger: 0.3,
        ease: "power1.out",
      });

    const penAnimation = gsap.timeline({ repeat: -1 });
    penAnimation.to("#pen", {
      duration: 0.7,
      translateY: "-5em",
      translateX: "-2em",
    });
    penAnimation.to("#pen", {
      duration: 0.7,
      translateX: "-7.5em",
    });
    penAnimation.to("#pen", {
      duration: 0.7,
      translateY: "1.5em",
      translateX: "-9em",
    });
    penAnimation.to("#pen", {
      duration: 0.7,
      translateX: "0.1em",
    });
    penAnimation.to("#pen", {
      duration: 0.7,
      translateY: "-0.99em",
    });

    const laptopAnimation = gsap.timeline({ repeat: -1 });
    laptopAnimation.to("#laptop-light", {
      duration: 1,
      opacity: 0,
    });
    laptopAnimation.yoyo(true);

    return () => {
      linesAnimation.kill();
      penAnimation.kill();
      laptopAnimation.kill();
    };
  }, [animate]);

  const svgClass = [LAPTOP_SVG_LAYOUT, className].filter(Boolean).join(" ");

  return <LaptopImage className={svgClass} />;
}
